<template>
  <div v-show="isActive" class="p-tab-panel">
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed, inject, type ComputedRef } from 'vue'

const props = defineProps<{
  id: string
  title?: string
  // `notification` is read by parent PTab via slot-vnode introspection; declared
  // here so Vue doesn't fall it through as an HTML attribute on the panel root.
  notification?: number
}>()

const activeId = inject<ComputedRef<string>>('pTabActiveId')

const isActive = computed(() => activeId?.value === props.id)
</script>
